import React from "react";
import "./App.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import Router from "./Router";
import { ThemeProvider } from "@material-ui/core/styles";

import theme from "./theme";

function App() {
	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				<Router />
			</ThemeProvider>
		</div>
	);
}

export default App;
